import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersistence from 'vuex-persist'

Vue.use(Vuex)

// store 持久化儲存
const vuexLocal = new VuexPersistence({
  storage: window.localStorage,
  reducer: state => ({
    xbbBonus: state.xbbBonus,
    token: state.token
  })
})

const store = new Vuex.Store({
  plugins: [vuexLocal.plugin],
  state: {
    tab: {
      image: 'sg/activity/2020/07/10/159436862710000.png',
      image_gray: 'sg/activity/2020/07/10/15943686349999.png',
      name: 'vip模块网址',
      open_type: 0,
      url: 'https://yaboxxxapp02.com/mobile'
    },
    isShowAd: window.__CONFIG__.VUE_APP_AD, // 是否展示广告
    xbbBonus: {
      isGuest: true,
      domain: '',
      userid: '',
      cid: '',
      wsUrl: '',
      promoUrl: '',
      ad: false,
      activity: false
    },
    token: '',
    appMoneyLink: '',
    resizeData: {
      clientWidth: null
    }
  },
  mutations: {
    setTab (state, data) {
      state.tab = Object.assign(state.tab, data)
    },
    setXbbBonusInit (state) {
      state.xbbBonus = {
        isGuest: true,
        domain: '',
        userid: '',
        cid: '',
        wsUrl: '',
        promoUrl: '',
        ad: false,
        activity: false
      }
    },
    setXbbBonus (state, options) {
      const {
        isGuest,
        domain,
        userid,
        cid,
        ws_url: wsUrl,
        promo_url: promoUrl,
        ad,
        activity,
        login_video_switch: loginVideoSwitch
      } = options

      state.xbbBonus = {
        isGuest,
        domain,
        userid,
        cid,
        wsUrl,
        promoUrl,
        ad,
        activity,
        loginVideoSwitch
      }
    },
    setToken (state, token) {
      state.token = token
    },
    setAppMoneyLink (state, link) {
      state.appMoneyLink = link
    },
    setResizeData (state, data) {
      state.resizeData = data
    }
  },
  actions: {},
  getters: {
    tab: state => state.tab,
    isShowAd: state => state.isShowAd,
    device: state => {
      let device = 'phone'
      if (state.resizeData.clientWidth >= 1024) {
        device = 'pc'
      } else if (state.resizeData.clientWidth >= 768) {
        device = 'tablet'
      }
      return device
    }
  }
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js